export default __webpack_public_path__ + "static/IM_logo_ciemne-cdd86474d8a589b24c9f7e59f23c0e17.png";